import { render, staticRenderFns } from "./NewEditLayout.vue?vue&type=template&id=0c64a180&"
import script from "../../models/app-design/new-edit-layout.ts?vue&type=script&lang=ts&"
export * from "../../models/app-design/new-edit-layout.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports